export default [{
    path: "/app/portfolio",
    name: "portfolio",
    redirect: {
        name: 'dashboard'
    },
    component: () => import("../../../../views/dashboard/customer/PortfolioComponent.vue"),
    children: [{
            path: ":portfolio",
            name: "portfolio.details",
            component: () => import("../../../../views/dashboard/customer/portfolio/PortfolioDetailsComponent.vue"),
            meta: {
                allowedUsers: ['customer']
            }
        },
        {
            path: ":portfolio/direct-debits",
            name: "portfolio.direct-debits",
            component: () => import("../../../../views/dashboard/customer/portfolio/DirectDebitComponent.vue"),
            meta: {
                allowedUsers: ['customer']
            }
        },
    ]
}]
